import type { Thunk } from 'editor/src/store/hooks';

import { getLibraryRequest } from '../selector';
import { setLibraryRequestAction } from '../slice';

// the host answers within its own request timeout; past this the answer is not coming
export const LIBRARY_REQUEST_TIMEOUT_MS = 20_000;

/** Turns the request just sent into a retryable failure if the host never answers it. */
const failUnansweredLibraryRequestOperation =
  (imageId: string): Thunk =>
  (dispatch, getState) => {
    const sentRequest = getLibraryRequest(getState(), imageId);
    if (sentRequest?.status !== 'pending') {
      return;
    }
    setTimeout(() => {
      // identity, not status: a newer request for the same image has its own timer
      if (getLibraryRequest(getState(), imageId) !== sentRequest) {
        return;
      }
      dispatch(
        setLibraryRequestAction({ imageId, request: { status: 'failed', saved: sentRequest.saved, timedOut: true } }),
      );
    }, LIBRARY_REQUEST_TIMEOUT_MS);
  };

export default failUnansweredLibraryRequestOperation;
